import { headerHeight } from "../../constants";

export const styles = {
  container: {
    position: "absolute",
    top: "100%",
    right: "0",
    left: "auto",
    marginTop: "8px",
    width: "450px",
    backgroundColor: "white",
    borderRadius: "15px",
    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
    zIndex: 1000,
    "@media (max-width: 600px)": {
      top: `${headerHeight}px`,
      width: "100vw",
      right: 0,
      left: 0,
      marginTop: 0,
      borderRadius: 0,
      position: "fixed",
    },
  },
  headerText: {
    p: 2,
    color: "#c1c1c1",
  },
  appsContainer: {
    p: 2,
    display: "flex",
    flexDirection: "column",
    gap: 3,
  },
  appItem: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    textDecoration: "none",
  },
  appIcon: {
    width: 110,
    height: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  appTitle: {
    fontWeight: 300,
    fontSize: 20,
    borderLeft: "1px solid",
    height: "20px",
    lineHeight: "20px",
    pl: 1,
  },
  description: {
    fontWeight: 300,
  },
};
